<!-- components/TokenExpiryModal.vue -->
<template>
  <div class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-md shadow-lg max-w-xl w-full">
            <div class="flex justify-between">
                <h2 class="text-xl font-semibold mb-4 text-neutral-800 flex space-x-3">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 12.001V14.6676M16 20.001H16.0134M6.76244 25.3343H25.2376C27.2904 25.3343 28.5735 23.1121 27.5471 21.3343L18.3094 5.33431C17.283 3.55653 14.717 3.55653 13.6906 5.33431L4.45304 21.3343C3.42664 23.1121 4.70964 25.3343 6.76244 25.3343Z" stroke="#CC4E06" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Are your still working on the form?</span>
                </h2>
            </div>
            <p class="text-base font-normal text-neutral-800">The form will time out in 5 minutes, and all progress will be lost. If you are still working on it, please press “Yes” to continue.</p>
            <div class="flex justify-end gap-3 mt-5">
                <button type="button" @click="extendToken" class="px-4 py-2 bg-primary-500 text-white rounded">Yes</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    methods: {
        extendToken() {
            axios({
                method: 'get',
                url: `bol-manufacturers/refresh-token`,
            }).then(res => {
                localStorage.setItem('auth_token', res.data.token)
                localStorage.setItem('expires_at', res.data.expiresAt);
                localStorage.setItem('token_type', 'bearer');
                localStorage.setItem('auth_type', 1);
                context.commit('setAuthData', {token: res.data.token, tokenType: 'bearer', expiresAt: res.data.token.expiresAt, authType: 1})
            }).catch(err => {
                console.log(err)
            })
            this.$emit('close');
        }
    }
};
</script>
